'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const timespan=require('pulsar-utils/dist-es6/time/timespan');let

DataRetentionPeriod=function(){
function DataRetentionPeriod(label){let numWeeks=arguments.length>1&&arguments[1]!==void 0?arguments[1]:null;_classCallCheck(this,DataRetentionPeriod);
this._label=label;
this._numWeeks=numWeeks;
this._value=_.exists(numWeeks)?timespan.fromDays(numWeeks*7).totalMilliseconds():null;
}DataRetentionPeriod.prototype.













valueOf=function valueOf(){
return this.value;
};DataRetentionPeriod.prototype.

toJSON=function toJSON(){
return this.value;
};_createClass(DataRetentionPeriod,[{key:'numWeeks',get:function(){return this._numWeeks}},{key:'label',get:function(){return this._label}},{key:'value',get:function(){return this._value}}]);return DataRetentionPeriod}();


module.exports=DataRetentionPeriod;
module.exports.AvailableDataRetentionPeriods=[
new DataRetentionPeriod('Keep all data',null),
new DataRetentionPeriod('6 months',26),
new DataRetentionPeriod('1 year',52)];
//# sourceMappingURL=dataRetentionPeriod.js.map
